// @Vendors
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// @State
import { selectUserLogged } from '../../../state/auth/auth.selectors';
import { doLogout } from '../../../state/auth/auth.actions';
// import { selectServerErrors, selectStatusError } from 'state/app/app.selectors';
// import { clearServerErrors } from 'state/app/app.actions';

// @Components
import TopNavBar from '../../../components/nav/TopNavBar';
import Nav from '../../../components/nav/Nav';
import {getAuthorizationToken, getSessionId} from "../../../utils/auth";

const hooliCod = ['HGATE', 'AAD', 'AUS', 'ACO', 'ABC']

class App extends Component {
  state = {
		navOpen: true
	}

	handleButtonNav = e => {
		const { navOpen } = this.state;
		this.setState({ navOpen: !navOpen })
		e.preventDefault();
		e.stopPropagation();
  }

  handleLinkClick = rol => {
    if(!hooliCod.includes(rol.servicioHooliCod)) return
    const {userLogged} = this.props;
    const url = new URL(process.env[`REACT_APP_${rol.servicioHooliCod}_URL`])
    console.log(process.env[`${rol.servicioHooliCod}_URL`]);
    url.searchParams.append("session", getSessionId())
    url.searchParams.append("token", getAuthorizationToken())
    url.searchParams.append("latitud", userLogged.latitud)
    url.searchParams.append("longitud", userLogged.longituf)
    rol.servicioHooliCod === "HGATE" && url.searchParams.append("merchantId", rol.merchantId)
    window.location = url.href
  }

  render() {
    const { children, userLogged, doLogout } = this.props;

		const { navOpen } = this.state;

    return (
      <div id='temp_backoffice' className={navOpen ? '' : 'collapse'}>
        <section id='temp_nav_bar'>
          <TopNavBar
            name={userLogged.usuarioNombres}
            onLogout={doLogout}
            pic='user/pic_backuser@2x.png'
            rol='BackUser'
            surname={userLogged.usuarioApellidos}
          />
          <Nav navOpen={navOpen} actionButtonNav={this.handleButtonNav} onLinkClick={this.handleLinkClick} roles={userLogged.roles} />
        </section>
        <section id='temp_body'>
          {children}
        </section>
    </div>
    );
  }
}

const mapStateToProps = state => ({
  // serverErrors: selectServerErrors(state),
  // statusError: selectStatusError(state),
  userLogged: selectUserLogged(state)
});

const actions = {
  // clearServerErrors,
  doLogout
};

export default withRouter(
  connect(
    mapStateToProps,
    actions
  )(App)
);



// WEBPACK FOOTER //
// ./src/pages/App/Templates/PageTemplate.js